module.exports = __webpack_public_path__ + "media/packs/images/panes/documents-8d3da21335ecaa80aaac10faf45652ef.svg";